import fetch from 'cross-fetch';
import Oy from 'oy-vey';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { emailConfig, isBrowser, isNotificationEnabled, url } from '../../config';
import { getp } from '../../helpers/getProp';
import logger, { logNotifications } from '../../logger';
import EmailTemplate from './template/EmailTemplate';
import { getSubject } from './template/subjects';

export async function sendEmail(to, type, content, isTest) {
  logger.trace('540.0 - sendEmail - enter');
  if (!isNotificationEnabled) {
    logNotifications('skipping email, not in production');
    return;
  }
  if (!to) {
    logNotifications(
      '540.0e - sendemail - Unable to send email, no email address provided',
      type,
      content,
    );
    return;
  }
  let from = emailConfig.sender + '<' + emailConfig.email + '>';
  let html, subject, previewText;
  let subjectData = getSubject(type);
  html = Oy.renderTemplate(
    <IntlProvider locale={'en'}>
      <EmailTemplate type={type} content={content} />
    </IntlProvider>,
    {
      title: subjectData.subject,
      previewText: subjectData.previewText,
    },
  );
  if (isTest) {
    return html;
  }

  let mailOptions = {
    from,
    to, // list of receivers
    subject: subjectData.subject, // Subject line
    //text: textMessage, // plain text body
    html,
  };
  logNotifications('540.1 - sendEmail - REST start');
  const sendUrl = isBrowser ? '/sendEmail' : url + '/sendEmail';
  const resp = await fetch(sendUrl, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ mailOptions }),
    credentials: 'include',
  }).catch(err => {
    logger.error('540.1e - Error sending email', err);
  });
  logNotifications('540.2 - sendEmail - REST end');
  const status = getp(resp, 'status') || 444;
  if (!status || +status !== 200) {
    logger.error('540.1f - *@* Email error', status, resp);
  }
  logNotifications('540.2 - sendEmail - end', status);
  return { status };
}



// WEBPACK FOOTER //
// ./src/core/email/sendEmail.js